module.exports = __webpack_public_path__ + "img/zijian.2bf39815.png";